import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import {
  ListOrganizations,
  listOrganizations,
} from '@/services/list-organizations'

export const GET_ORGANIZATION_QUERY = 'GET_ORGANIZATIONS'

interface useGetOrganizationsProps {
  enabled: boolean
  onSuccess?: (data: ListOrganizations) => void
}

export const useGetOrganizations = ({
  enabled,
  onSuccess,
}: useGetOrganizationsProps) => {
  const query = useQuery({
    queryKey: [GET_ORGANIZATION_QUERY],
    queryFn: ({ signal }) => listOrganizations({ signal }),
    enabled,
    onSuccess,
    cacheTime: 0,
    onError() {
      toast.error(
        'Falha na conexão, selecione a opção "Não quero enviar nenhum arquivo para o Operations Center" e em seguida "Concluir", para exportar seu mapa de pulverização.',
      )
    },
  })

  return query
}
